import { PUSH_RENDER_PDF_TEMPLATE_IMAGE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    url: string;
    error?: string;
}

export default (formData: FormData, forNewDrugs?: boolean): Promise<Response> =>
    fetchWithRefresh(PUSH_RENDER_PDF_TEMPLATE_IMAGE(forNewDrugs), {
        method: 'POST',
        body: formData,
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('upload render pdf template image failed');
        }
    });
